module.exports = __webpack_public_path__ + "img/665-a70cb5.png";